<template>
  <el-dialog
    class="dialog"
    :visible="isShow"
    width="40%"
    @close="handleClose">
      <YPlay :videoUrl="videoUrl" class="dialog-video" controls></YPlay>
  </el-dialog>

</template>

<script>
import YPlay from '@/components/y-player.vue';

export default {
  props: {
    isShow: {
      type: Boolean,
      require: true,
    },
    type: {
      type: Boolean,
      default: true,
    },
    videoUrl: {
      type: String,
    },
    overallMastery: {
      type: String,
    },
    basicUrl: {},
    consolidateUrl: {},
    handout: {},
  },
  components: {
    YPlay,
  },
  data() {
    return {
      switchover: true,
      url: '',
      activeName: 'basics',
      rowName: '',
    };
  },
  mounted() {
    this.bgWidth();
  },
  methods: {
    handleClose() {
      // this.$emit('handleClose');
      this.$emit('update:isShow', false);
    },
    switchoverShow() {
      if (this.basicUrl || this.consolidateUrl) {
        this.switchover = false;
      }
    },
    // 获取知识点标题的宽度
    bgWidth() {
      // 兼容处理，别的页面没有这个class,需判断
      if (document.getElementById('title-box')) {
        document.getElementById('title-box').style.width = `${document.getElementById('box').offsetWidth}px`;
      }
    },
    copy(url) {
      this.getShortUrl(url);
    },
  },
};
</script>

<style lang='scss' scoped>
 .active {
   background-color:  #E6F1FC;
   color: #1989FA;
   border-color: #A3D0FD !important;
 }
 .right {
   right: 20px;
 }
 .float {
   float: right;
   margin-right: 50px;
 }
.dialog {
  box-sizing: border-box;
  // overflow: hidden;
  /deep/ .el-dialog {
    padding: 20px;
    margin-top: 40px !important;
    &__body {
      padding: 10px 20px;
    }
    .el-icon-close:before {
    content: "\e6db";
    position: relative;
    top: -12px;
    right: -10px;
    font-size: 20px;
}
  }
   #input {
    position: absolute;
    top: 1000px;
    opacity: 0;
      }
  &-hint {
    margin-top: 48px;
    margin-bottom: 16px;
    font-size: 14px;
    color: #606266;
  }
  .title-text {
    font-size: 24px;
    font-family: 'PingFangSC-Medium', 'PingFang SC';
    font-weight: 500;
    width: 66%;
    color: #000000;
    #title-text {
      font-size: 18px;
    }
    #title-box {
        // width: 129px;
        position: relative;
        height: 13px;
        top: -17px;
        left: 10px;
        background: rgba(230, 162, 60, 0.2);
        border-radius: 7px;
      }
      &__line {
        float: left;
        margin-top: 5px;
        margin-right: 8px;
        width: 3px;
        height: 16px;
        background: #1890FF;
        border-radius: 3px;
      }
    }
    .copy-button {
      position: relative;
      top: 32px;
      right: 0;
    }
    &-tabs {
      position: absolute;
      top: 34px;
      right: -15px;
      margin: auto;
      width: 300px;
      height: 36px;

      line-height: 36px;

      font-weight: 500;
      font-size: 16px;
      &__video {
        width: 120px;
        display: inline-block;
        text-align: center;
        border: 1px solid #E4E7ED;
        border-radius: 4px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0;
      }
      &__handouts {
        width: 120px;
        display: inline-block;
        text-align: center;
        border: 1px solid #E4E7ED;
        border-radius: 4px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0;
      }
    }
    &-video {
      width: 100%;
      margin-top: 10px;
    }
    &-image {
      width: 100%;
      max-height: 625px;
      overflow: hidden;
      overflow-y: auto;
      /deep/ img {
        width: 100%;
      }
    }
}

</style>
